import React from 'react';
import { Play, DollarSign, Share2 } from 'lucide-react';

/**
 * LoteVideo - Video section with action buttons and agent contact
 */
const LoteVideo = ({
    lote,
    showButtons = true,
    onPreofertar,
    onShare
}) => {
    return (
        <div className="w-full lg:w-[45%] bg-white rounded shadow-md p-2">
            <h2 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-1">
                <Play className="w-4 h-4 text-green-600" />
                Video del lote
            </h2>
            <div
                className="rounded w-full relative overflow-hidden"
                style={{ backgroundColor: '#111', paddingTop: '56.25%' }}
            >
                {lote.video_url ? (
                    lote.video_url.includes('vimeo') ? (
                        <iframe
                            src={`https://player.vimeo.com/video/${lote.video_url.split('/')[3]}?autoplay=1&loop=1&color=ffffff&byline=0&portrait=0&title=0&muted=1`}
                            className="rounded"
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                            title="Video del lote"
                        />
                    ) : lote.video_url.includes('mediadelivery') ? (
                        <iframe
                            src={`https://iframe.mediadelivery.net/embed/${lote.video_url.split('/')[4]}/${lote.video_url.split('/')[5]}?autoplay=true&loop=true&muted=true&preload=true`}
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                            title="Video del lote"
                        />
                    ) : (
                        <p className="absolute text-white font-bold text-lg uppercase" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                            Video no disponible
                        </p>
                    )
                ) : (
                    <div className="absolute inset-0 cursor-pointer group">
                        <img
                            src="/video-preview.png"
                            alt="Preview del lote"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all flex items-center justify-center">
                            <div className="bg-white/90 rounded-full p-4 group-hover:scale-110 transition-transform">
                                <Play className="w-8 h-8 text-green-600 fill-green-600" />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Botones de acción */}
            {showButtons && (
                <div className="flex gap-2 mt-3">
                    <button
                        disabled={lote.venta_estado === 'VE' || lote.venta_estado === 'NV'}
                        onClick={onPreofertar}
                        className={`flex-1 py-3 rounded-lg font-bold text-sm transition-all shadow-md flex items-center justify-center gap-2 ${lote.venta_estado === 'VE' || lote.venta_estado === 'NV'
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white hover:shadow-lg'
                            }`}
                    >
                        <DollarSign className="w-5 h-5" />
                        Preofertar
                    </button>
                    <button
                        onClick={onShare}
                        className="border-2 border-green-600 text-green-600 hover:bg-green-50 px-4 py-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2"
                    >
                        <Share2 className="w-5 h-5" />
                        Compartir
                    </button>
                </div>
            )}

            {/* Agente de ventas */}
            {lote.agente_nombre && lote.agente_telefono && (
                <div className="mt-3 bg-gradient-to-r from-green-50 to-green-100 rounded-lg p-3 border border-green-200">
                    <p className="text-xs text-green-700 font-semibold mb-2">Agente de ventas</p>
                    <div className="flex items-center justify-between gap-3">
                        <div>
                            <p className="font-bold text-green-900 text-sm">{lote.agente_nombre}</p>
                            <p className="text-xs text-green-600">{lote.agente_telefono}</p>
                        </div>
                        <a
                            href={`https://wa.me/598${lote.agente_telefono.replace(/^0/, '')}?text=${encodeURIComponent(`¡Hola! Estoy interesado en el Lote #${lote.numero_lote} del Remate #${lote.remate_numero} de Plaza Rural.`)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-semibold text-sm transition-all shadow-md hover:shadow-lg"
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                            </svg>
                            Contactar
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoteVideo;
